import { SuspenseQueryWith } from '@/utils/types'
import { useSuspenseQuery } from '@tanstack/react-query'
import { HyperCoreAsset, hyperCoreAssetsQueryOptions } from './querySpotMeta'

export type UseHyperCoreSpotMetaResult = SuspenseQueryWith<{
  assets: HyperCoreAsset[]
}>

export function useHyperCoreSpotMeta(): UseHyperCoreSpotMetaResult {

  const response = useSuspenseQuery({
    ...hyperCoreAssetsQueryOptions(),
  })

  return {
    ...response,
    assets: response.data,
  }
}
